import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useSession } from './useSession';
import { DEV_MODE } from './config';

interface SessionGuardProps {
  children: ReactNode;
  requireAuth?: boolean;
}

export function SessionGuard({ children, requireAuth = true }: SessionGuardProps) {
  const { session, loading } = useSession();

  // In dev mode, bypass all auth checks
  if (DEV_MODE) {
    return (
      <>
        {requireAuth && (
          <div className="fixed top-0 left-0 right-0 z-50 bg-yellow-500 text-black text-center py-1 text-xs font-bold">
            🔧 DEVELOPER MODE - Authentication Bypassed
          </div>
        )}
        <div className={requireAuth ? "pt-6" : ""}>
          {children}
        </div>
      </>
    );
  }

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (requireAuth && !session) {
    return <Navigate to="/auth" replace />;
  }

  if (!requireAuth && session) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
